import React, { useState, useEffect, useContext } from "react";
import "../../css/style.css";
import Footer from "../Footer";
import Navigation from "../NavigationPanel/Navigation";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { BsEyeFill } from "react-icons/bs";
import { DashboardContext } from "../../ContextApi";
import DatePicker from "react-datepicker";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { FilterMatchMode } from "primereact/api";
import { InputText } from "primereact/inputtext";
import "../../css/datatable.css";
import { useTranslation } from "react-i18next";
import { FaArrowRightFromBracket } from "react-icons/fa6";
import ModalImage from "../Error-Span-Modal/ModalImage";
import ModalError from "../Error-Span-Modal/ModalError";
import { BarLoader, CircleLoader, ClipLoader } from "react-spinners";

const override = {
  display: "block",
  margin: "20% auto ",
  borderColor: "white",
};

function DashboardindexDetails() {
  const { t } = useTranslation();
  const { dashboardUrl } = useContext(DashboardContext);
  const { setRejectedServiceDetails } = useContext(DashboardContext);
  const { setServiceViewDetails } = useContext(DashboardContext);
  const isLoginpage = true;
  const isLogedin = true;
  const MasterKey = process.env.REACT_APP_OWCS_MASTER_SERVICE;
  const LegalizationKey = process.env.REACT_APP_LEGALIZATION_KEY;
  const [formChange, setFormChange] = useState("ApplyforSelf");
  const [dashboardData, setDashboardData] = useState([]);
  const [status, setStatus] = useState("");
  const [processStatus, setProcessStatus] = useState("");
  const [filters, setFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
  });
  let Navigate = useNavigate();
  const [isAuthenticated, setIsAuthenticated] = useState(true);
  
  useEffect(() => {
    if(sessionStorage.getItem('accessToken') !== null && sessionStorage.getItem('authToken') !== null){
      console.log('accesstoken', sessionStorage.getItem('accessToken'))
      console.log('authtyoken', sessionStorage.getItem('authToken'))
      setIsAuthenticated(true);
    }
    else{
      console.log('not verified')
      setIsAuthenticated(false);
    }
  },[])
 
  
  
  useEffect(() => {
    if (!isAuthenticated) {
      console.log('here to navigate')
      Navigate('/');
    }
  }, [isAuthenticated]);
  const [isPaymentApplicable, setPaymentApplicable] = useState("");
  const [paymentQRModal, setPaymentQRModal] = useState(false);
  const [paymentQRBase64, setPaymentQRBase64] = useState('');
  const [ImageQRBase64,setImageQRBase64]=useState("");
  const [ImageName,setImageName]=useState("");

  const [failedpaymentQRModal, setFailedpaymentQRModal] = useState(false);
  const [timeoutModal, setTimeoutModal] = useState(false)
  const [error, setError] = useState("");
  const [errorClass, setErrorClass] = useState("");
  const [applicationNumber, setApplicationNumber] = useState('');
  const [amount, setAmount] = useState(0);
  const [description, setDescription]= useState('');
  const [paymentErrorMsg, setPaymentErrorMsg] = useState('');
  const [isloading, setIsloading] = useState(false);
  
  function qrTimeout(){
    setPaymentQRModal(false);
    setTimeoutModal(true);
    setError("d9f21091f3007ccdff04d8ed57cf13dc");
    errorHandel(0);
  }

  const getPaymentAmount = (value) => {
    if (value === null || value === undefined || value === "") {
      return 0;
    }

    const amountValue = Number(String(value).replace(/,/g, ""));
    return Number.isFinite(amountValue) ? amountValue : 0;
  };

  const formatPaymentAmount = (value) => {
    const amountValue = getPaymentAmount(value);
    return amountValue.toFixed(2);
  };

  // ALL SERVICES ARE NOW ELIGIBLE FOR PAYMENT
  // Removed the tourism service restriction - all services can now generate payment QR codes
  const isServiceEligibleForPayment = (serviceCode) => {
    // All services are now eligible for payment
    return true;
  };

  const columns = [
    { field: "code", header: "Code" },
    { field: "name", header: "Name" },
    { field: "category", header: "Category" },
    { field: "quantity", header: "Quantity" },
  ];

  useEffect(() => {
    if (sessionStorage.getItem("customerId")) {
      const customerId = sessionStorage.getItem("customerId");

      const formData = {
        typeId: 3,
        customerId: customerId,
        status: dashboardUrl.status,
        processStatus: dashboardUrl.processStatus,
      };

      let config = {
        headers: {
          AuthToken: "Bearer " + `${sessionStorage.getItem("authToken")}`,
        },
      };

      axios
        .post(`${MasterKey}/getDashBoardDetails`, formData, config)
        .then((response) => {
          // setIsloading(false)
          if (response.data.status == 1) {
            let dashboardData = response.data.responseObject.Data.Transactions;
            setPaymentApplicable(response.data.responseObject.Data.isPaymentApplicable)
            setDashboardData(dashboardData.reverse());
          }
        })
        .catch((err) => {
          // setIsloading(false)
          console.log(err);
        });
    }
  }, []);

  useEffect(() => {
    if (localStorage.getItem("firstLoadDone") === null) {
      // If it's the first load, set the flag in local storage to true and reload the page
      localStorage.setItem("firstLoadDone", 1);
    } else {
      Navigate("/dashboard");
      localStorage.removeItem("firstLoadDone");
    }
  }, []);

  const getApplication = (requestCode, serviceName) => {
    let tokenss = sessionStorage.getItem("accessToken");
    let data = {
      serviceApplicationRegisterCode: requestCode,
      loggedinUserCode: sessionStorage.getItem("userId"),
    };
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: tokenss,
        AuthToken: "Bearer " + `${sessionStorage.getItem("authToken")}`,
      },
      responseType: "blob",
      body: JSON.stringify(data),
    };
    fetch(
      `${LegalizationKey}/downloadLegalizationApplication`,
      requestOptions
    ).then((response) => {
      response.blob().then((data) => {
        const url = window.URL.createObjectURL(new Blob([data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `${serviceName}_${requestCode}.pdf`);
        document.body.appendChild(link);
        link.click();
      });
    });
  };

  const getReceipt = (registerCode, serviceName) => {
    let tokenss = sessionStorage.getItem("accessToken");
    let data = {
      serviceApplicationCode: registerCode,
      loggedinUserCode: sessionStorage.getItem("userId"),
    };
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: tokenss,
        AuthToken: "Bearer " + `${sessionStorage.getItem("authToken")}`,
      },
      responseType: "blob",
      body: JSON.stringify(data),
    };
    fetch(
      `${LegalizationKey}/downloadLegalizationReceipt`,
      requestOptions
    ).then((response) => {
      response.blob().then((data) => {
        const url = window.URL.createObjectURL(new Blob([data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          `${serviceName}_${registerCode}_Receipt.pdf`
        );
        document.body.appendChild(link);
        link.click();
      });
    });
  };

  const getPayment = (registerCode, serviceName) => {
    let tokenss = sessionStorage.getItem("accessToken");
    let data = {
      serviceApplicationCode: registerCode,
      loggedinUserCode: sessionStorage.getItem("userId"),
    };
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: tokenss,
        AuthToken: "Bearer " + `${sessionStorage.getItem("authToken")}`,
      },
      responseType: "blob",
      body: JSON.stringify(data),
    };
    fetch(
      `${LegalizationKey}/downloadPaymentReceipt`,
      requestOptions
    ).then((response) => {
      response.blob().then((data) => {
        const url = window.URL.createObjectURL(new Blob([data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          `${serviceName}_${registerCode}_Payment_Receipt.pdf`
        );
        document.body.appendChild(link);
        link.click();
      });
    });
  };

  // CORRECTED: Enhanced payment function with proper quantity and amount handling for all services
  const completePayment = (dashboard) => {
    const registerCode = dashboard.RequestCode;
    // Get the amount and quantity from the dashboard
    const paymentAmount = getPaymentAmount(dashboard.Amount);
    const quantity = dashboard.Quantity || dashboard.quantity || 1;
    
    console.log('Processing payment for service:', dashboard.ServiceName);
    console.log('Service Code:', dashboard.ServiceCode);
    console.log('Payment Amount:', paymentAmount);
    console.log('Quantity:', quantity);
    
    setApplicationNumber(registerCode);
    setIsloading(true);
    
    if (sessionStorage.getItem("accessToken")) {
      let tokenss = sessionStorage.getItem("accessToken");
       
      var config = {
        headers: {
          Authorization: tokenss,
          AuthToken: "Bearer " + `${sessionStorage.getItem("authToken")}`
        },
      };
    }
    
    // Create request body with all necessary fields
    const reqBody = {
      requestCode: registerCode,
      loggedInUserCode: sessionStorage.getItem("userId"),
      amount: paymentAmount,
      quantity: quantity, // Include quantity to ensure correct receipt
      serviceCode: dashboard.ServiceCode, // Include service code if needed
      serviceName: dashboard.ServiceName // Include service name if needed
    };
    
    console.log('Request body:', reqBody);
    
    axios.post(`${LegalizationKey}/fetchQRForPayment`, reqBody, config)
    .then((response) => {
      setIsloading(false);
      console.log('Payment QR response:', response.data);
      
      if(response.data.responseObject.IsError === false){
        console.log('QR generated successfully for service:', dashboard.ServiceName);
        const qrbase64 = response.data.responseObject.Data.QrCode
        const base64Image = `data:image/png;base64,${qrbase64}`
        setImageQRBase64(base64Image);
        setImageName('qr_payment');
        setPaymentQRModal(true);
        
        // Get response data
        const responseData = response.data.responseObject.Data;
        
        // Set description from response or create a default one with quantity
        if(responseData.Receipt?.Description !== null && responseData.Receipt?.Description !== undefined) {
          setDescription(responseData.Receipt.Description);
        } else {
          setDescription(`Payment for ${dashboard.ServiceName} (Quantity: ${quantity}) - Application: ${registerCode}`);
        }
        
        // Set the amount - use the amount from response if available, otherwise use the paymentAmount
        const responseAmount = responseData.NBC?.data?.amount || paymentAmount;
        setAmount(formatPaymentAmount(responseAmount));
        
        // Check if quantity matches and log warning if not
        const responseQuantity = responseData.Receipt?.Quantity || quantity;
        if (responseQuantity !== quantity) {
          console.warn(`Quantity mismatch - Transaction: ${quantity}, Receipt: ${responseQuantity}`);
        }
        
        // Store payment info in session for tracking
        sessionStorage.setItem('lastPaymentAmount', responseAmount);
        sessionStorage.setItem('lastPaymentService', dashboard.ServiceName);
        sessionStorage.setItem('lastPaymentQuantity', quantity);
        
      } else {
        console.log('Payment QR generation failed:', response.data.responseObject.ErrorMessage);
        setFailedpaymentQRModal(true);
        setError(response.data.responseObject.ErrorMessage || "Failed to generate payment QR code");
        errorHandel(0);
        return;
      }
    })
    .catch((error) => {
      setIsloading(false);
      console.error('Payment error:', error);
      setFailedpaymentQRModal(true);
      setError("Payment service error. Please try again later.");
      errorHandel(0);
    });
  }
  
  const registeredDate = (dashboard) => {
    return (
      <DatePicker
        disabled={true}
        className={`form-control transparentBg`}
        dateFormat="dd/MM/yyyy"
        selected={dashboard.DateRegistered?.substr(0, 10)}
      />
    );
  };

  const downloadApplication = (dashboard) => {
    return (
      <div style={{ display: "flex", justifyContent: "space-evenly" }}>
        <button
          className="download"
          onClick={() =>
            getApplication(dashboard.RequestCode, dashboard.ServiceName)
          }
        >
          <i
            style={{ color: "green" }}
            className="fa fa-download"
            aria-hidden="true"
          ></i>
        </button>
      </div>
    );
  };

  const downloadReciept = (dashboard) => {
    return (
      <div style={{ display: "flex", justifyContent: "space-evenly" }}>
        <button
          className="download"
          onClick={() =>
            getReceipt(dashboard.RegisterCode, dashboard.ServiceName)
          }
        >
          <i
            style={{ color: "red" }}
            className="fa fa-download"
            aria-hidden="true"
          ></i>
        </button>
      </div>
    );
  };

  const downloadPayment = (dashboard) => {
    return (
      <div style={{ display: "flex", justifyContent: "space-evenly" }}>
        <button
          className="download"
          onClick={() =>
            getPayment(dashboard.RequestCode, dashboard.ServiceName)
          }
        >
          <i
            style={{ color: "blue" }}
            className="fa fa-download"
            aria-hidden="true"
          ></i>
        </button>
      </div>
    );
  };

  // CORRECTED: All services can now make payment regardless of amount
  // The button is enabled for ALL services
  const makePayment = (dashboard) => {
    const paymentAmount = getPaymentAmount(dashboard.Amount);
    const quantity = dashboard.Quantity || dashboard.quantity || 1;
    // All services are now eligible for payment - button is always enabled
    const isPaymentEnabled = true;
    
    // Log for debugging
    console.log(`Payment button for ${dashboard.ServiceName}: ServiceCode=${dashboard.ServiceCode}, Amount=${paymentAmount}, Quantity=${quantity}, Enabled=${isPaymentEnabled}`);

    return (
      <div style={{ display: "flex", justifyContent: "space-evenly" }}>
        <button
          className="download"
          onClick={() => completePayment(dashboard)}
          disabled={!isPaymentEnabled}
          title={isPaymentEnabled ? `Pay ${formatPaymentAmount(paymentAmount)} for ${dashboard.ServiceName} (Quantity: ${quantity})` : "Payment not available"}
        >
          <i
            style={{ color: isPaymentEnabled ? "#28a745" : "#cbb8b8d4" }}
            className="fas fa-wallet"
            aria-hidden="true"
          ></i>
        </button>
      </div>
    );
  }

  const viewApplication = (dashboard) => {
    return (
      <BsEyeFill
        style={{ cursor: "pointer" }}
        onClick={() => goToServiceView(dashboard)}
      />
    );
  };

  const redirectApplication = (dashboard) => {
    return (
      <FaArrowRightFromBracket
        style={{ cursor: "pointer" }}
        onClick={() => goToServiceRejection(dashboard)}
      />
    );
  };

  const goToServiceRejection = (dashboard) => {
    setRejectedServiceDetails(dashboard);
    switch (dashboard.ServiceCode) {
      case 2010019:
        Navigate("/rejectionService");
        break;
      case 2010010:
        Navigate("/rejectionService");
        break;
      case 2010020:
        Navigate("/rejectionService");
        break;
      case 215001:
        Navigate("/rejectionService");
        break;
      case 215002:
        Navigate("/rejectionService");
        break;
      case 215003:
        Navigate("/rejectionService");
        break;
      case 2040001:
        Navigate("/rejectionTourismService");
        break;
      case 2040002:
        Navigate("/rejectionTourismService");
        break;
      case 2040003:
        Navigate("/rejectionTourismService");
        break;
      default:
        Navigate("/rejectionService");
        return null;
    }
  };

  const goToServiceView = (dashboard) => {
    console.log(dashboard);
    sessionStorage.setItem("isVisitFromNotification",false)
    setServiceViewDetails(dashboard);
    Navigate("/viewService")
  };
 
  
  const imageClose=(e)=>{
      setPaymentQRModal(e);
      Navigate('/dashboard')
  }

  const errorHandel = (e) => {
    if (e == 0) {
      setErrorClass("errorMessage");
    } else {
      setErrorClass("successMessage");
    }
  };
 
  const errorClose = (e) => {
    setFailedpaymentQRModal(e);
    setTimeoutModal(e);
  };
  
  return (
    <div>
      {
        paymentQRModal && (
          <ModalImage  
            imageName={ImageName} 
            imageBase64={ImageQRBase64} 
            imageClose={imageClose} 
            isQR={true} 
            qrTimeout={qrTimeout} 
            applicationNumber={applicationNumber} 
            amount={amount} 
            description={description}
          />
        )
      }

      {
        failedpaymentQRModal && (
          <ModalError error={error} errorClose={errorClose} />
        )
      }

      {
        timeoutModal && (
          <ModalError error={error} errorClose={errorClose} />
        )
      }
      
      <Navigation page={isLoginpage} login={isLogedin} />

      <div id="layoutSidenav_content">
        <main>
          <header className="page-header page-header-dark bg-gradient-primary-to-secondary1 pb-5 pt-2">
            <div className="container">
              <div className="page-header-content padding-0">
                <div className="row d-flex">
                  <div className="p-2 col-12 col-sm-12 col-md-12 col-lg-12">
                    <h1
                      className="page-header-title KhmerOSmuollighttext"
                      style={{ fontSize: "20px"}}
                    >
                      <div className="page-header-icon">
                        <i data-feather="activity"></i>
                      </div>
                      {dashboardUrl.name}
                    </h1>
                  </div>
                </div>
              </div>
            </div>
          </header>

          {/* Main page content*/}
          <div className="container mt-sm-n5">
            <div className="row">
              <div className="col-lg-12 col-md-12 col-sm-12">
                <div
                  className="card card-lg mb-4"
                  style={{ backgroundColor: "rgb(17,126,191, 0.8)" }}
                >
                  <div className="card-header" style={{ color: "#fff" }}>
                    <div>
                      <div
                        className="flex justify-content-end"
                        style={{ display: "flex", marginBottom: "5px" }}
                      >
                        <span
                          className="p-input-icon-left"
                          style={{ width: "500px" }}
                        >
                          <i className="fa fa-search" aria-hidden="true"></i>
                          <InputText
                            style={{ paddingLeft: "2rem" }}
                            className="form-control"
                            onInput={(e) => {
                              setFilters({
                                global: {
                                  value: e.target.value,
                                  matchMode: FilterMatchMode.CONTAINS,
                                },
                              });
                            }}
                          />
                        </span>
                      </div>
                      <DataTable
                        className="KhmerOSsiemreaptext"
                        value={dashboardData}
                        tableStyle={{ minWidth: "50rem" }}
                        sortMode="multiple"
                        filters={filters}
                        paginator
                        showGridlines
                        rows={5}
                        emptyMessage={t("087fb8756d4add87f2d162304ccd486b")}
                        rowsPerPageOptions={[5, 10, 25, 50, 100]}
                        stripedRows
                        removableSort
                      >
                        <Column
                          style={{ width: "120px" }}
                          field="RequestCode"
                          header={t("9fc6c130df428afee946043e4b852b88")}
                          sortable
                        />
                        <Column
                          style={{ width: "300px" }}
                          field="ServiceName"
                          header={t("46140fd4f90101f3beccfd3428bea873")}
                          sortable
                        />
                        {dashboardUrl.status === "PENDING" && 
                          <Column
                            style={{ width: "120px"}}
                            field="Location"
                            header='Location'
                          />
                        }
                        <Column
                          style={{ width: "100px", textAlign: "center" }}
                          field=""
                          header={t("97ce2ccb5de5849fd94203a375054378")}
                          body={registeredDate}
                        />
                        <Column
                          style={{ width: "50px", textAlign: "center" }}
                          field=""
                          header={t("b179b5b6920cdd2c6a6a06473f84987b")}
                          body={downloadApplication}
                        />
                        {dashboardUrl.status === "PENDING" && (
                          <Column
                            style={{ width: "100px", textAlign: "center" }}
                            field=""
                            header={t("c60450b18b452cd3050cd479da30e3e1")}
                            body={viewApplication}
                          />
                        )}
                        {dashboardUrl.status === "PAID" && (
                          <Column
                            style={{ width: "120px", textAlign: "center" }}
                            field=""
                            header={t("44c603850b867ef1bbd8f29ad3f84e80")}
                            body={downloadPayment}
                          />
                        )}
                        {/* CORRECTED: Payment column now shows for ALL services in APPROVED status */}
                        {/* Removed any restrictions - all services can make payment */}
                        {dashboardUrl.status === "APPROVED" && (
                          <Column
                            style={{ width: "120px", textAlign: "center" }}
                            field=""
                            header="Payment"
                            body={makePayment}
                          />
                        )}
                        {dashboardUrl.status === "CLOSED" && (
                          <Column
                            style={{ width: "50px", textAlign: "center" }}
                            field=""
                            header={t("9302b43c215ea9f19d5c7d7d3a3e10b0")}
                            body={downloadReciept}
                          />
                        )}
                        {dashboardUrl.status === "RETURN" && (
                          <Column
                            style={{ width: "50px", textAlign: "center" }}
                            field=""
                            header={t("004bf6c9a40003140292e97330236c53")}
                            body={redirectApplication}
                          />
                        )}
                      </DataTable>
                    </div>
                  </div>
                </div>
              </div>
              <div style={{ margin: "30px", width: "100%" }}></div>
            </div>
          </div>
        </main>
      </div>

      <Footer />
      {isloading && (
        <div className="loderdiv">
          <ClipLoader
            color="hsla(203, 66%, 53%, 1)"
            size={80}
            cssOverride={override}
          />
        </div>
      )}
    </div>
  );
}

export default DashboardindexDetails;